import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import Icon from '../Icon';
import iconNext from '../../../../images/icons/Vitra_Next.svg';
import ListEntryImage from '../ListEntryImage';
import ListEntryDelete from './ListEntryDelete';
import styles from './list-entry.scss';
import CSSModules from 'react-css-modules';
import TextSlider from '../../shared/TextSlider';

const ListEntry = (props) => {
    const { id, deleteEntry, linkUrl, imageUrl, iconBar, title, txt } = props.entry;

    const handleClick = () => {
        window.setTimeout(function () {
            window.scrollTo(0,0);
        }, 500);
    };

    return (
        <li styleName={ !!deleteEntry ? 'removable-item' : 'item' }>
            <div styleName="wrapper">
                { !!deleteEntry && <ListEntryDelete onClick={deleteEntry} id={id} /> }
                <div onClick={handleClick}>
                    <Link styleName="link" to={linkUrl}>
                        <ListEntryImage imageUrl={imageUrl} />
                        <div styleName="text">
                            { !!iconBar && iconBar }
                            <TextSlider>
                                <h3 styleName="title">{ title }</h3>
                            </TextSlider>
                            <TextSlider>
                                <p styleName="artist">{ txt }</p>
                            </TextSlider>
                        </div>
                        <div styleName="linkIcon">
                            <Icon glyph={iconNext} />
                        </div>
                    </Link>
                </div>
            </div>
        </li>
    );
};

ListEntry.propTypes = {
    entry: PropTypes.object.isRequired,
};

export default CSSModules(ListEntry, styles);


// WEBPACK FOOTER //
// ./app/components/shared/ListEntry/index.jsx